/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Paytiko
 */
export class Paytiko {
    /**
     *
     * @type {string}
     * @memberof Paytiko
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Paytiko
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Paytiko
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Paytiko
     */
    type: string;
    /**
     *
     * @type {boolean}
     * @memberof Paytiko
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Paytiko
     */
    autoApprove: boolean;
}
